import axios from 'axios'
import { setIsTimeOut } from 'redux/actions/users'
import { store } from 'store'

const API_URL = process.env.REACT_APP_PRODUCTION_API_ENDPOINT?.replace('/graphql', '')
const SESSION_TIME_OUT = 2 * 60 * 60 * 1000

const authToken = () => {
  const token = localStorage.getItem('accessToken')
  const lastTimeRequest = localStorage.getItem('lastTimeRequest') as string
  const currentTime = Date.parse(new Date() as any)
  if (lastTimeRequest && currentTime - Number(lastTimeRequest) >= SESSION_TIME_OUT) {
    store.dispatch(setIsTimeOut(true))
    localStorage.setItem('lastTimeRequest', '')
  } else {
    store.dispatch(setIsTimeOut(false))
    localStorage.setItem('lastTimeRequest', `${currentTime}`)
  }

  return token ? `Bearer ${token}` : ''
}

export const instance = axios.create({
  baseURL: `${API_URL}/api/v1`,
  timeout: 15000,
  headers: { 'X-Custom-Header': 'foobar', Authorization: authToken() },
})

export default instance
